import { useDispatch, useSelector } from "react-redux";


export default function useFilter() {
    let dispatch = useDispatch()

    const doFilter = (sliceFilters, sliceItems, sliceActions) => {
        let filter = sliceFilters
        let items = sliceItems
        let actions = sliceActions

        let filteredItems = items
        Object.keys(filter).forEach((key) => {
            let filterValue = filter[key]

            switch (key) {
                case 'type':
                    if (filterValue) {
                        let nfp = []
                        Object.keys(items).forEach((key) => {
                            let item = items[key]

                            if (item.type == filterValue) {
                                nfp.push(item)
                            }
                        })

                        filteredItems = nfp
                    }

                    break
                case 'search':

                    if (filterValue) {
                        let nfp = []
                        Object.keys(filteredItems).forEach((key) => {
                            let item = filteredItems[key]

                            if (item.email!==undefined && item.email.toLowerCase().includes(filterValue.toLowerCase())) {

                                if (!isInObject(nfp, item,'email')) {
                                    nfp.push(item)
                                }
                            }

                            if (item.username!==undefined && item.username.toLowerCase().includes(filterValue.toLowerCase())) {

                                if (!isInObject(nfp, item,'username')) {
                                    nfp.push(item)
                                }
                            }

                            if (item.order_id!==undefined && item.order_id.toLowerCase().includes(filterValue.toLowerCase())) {

                                if (!isInObject(nfp, item,'order_id')) {
                                    nfp.push(item)
                                }
                            }

                            if (item.title!==undefined && item.title.toLowerCase().includes(filterValue.toLowerCase())) {

                                if (!isInObject(nfp, item,'title')) {
                                    nfp.push(item)
                                }
                            }

                            if (item.type!==undefined && item.type.toLowerCase().includes(filterValue.toLowerCase())) {

                                if (!isInObject(nfp, item,'type')) {
                                    nfp.push(item)
                                }
                            }

                            if (item.user_id!==undefined && item.user_id==filterValue) {

                                if (!isInObject(nfp, item,'user_id')) {
                                    nfp.push(item)
                                }
                            }

                            if (item.method!==undefined && item.method.toLowerCase().includes(filterValue.toLowerCase())) {

                                if (!isInObject(nfp, item,'method')) {
                                    nfp.push(item)
                                }
                            }

                            if (item.ptype!==undefined && item.ptype.toLowerCase().includes(filterValue.toLowerCase())) {

                                if (!isInObject(nfp, item,'ptype')) {
                                    nfp.push(item)
                                }
                            }

                            if (item.ptitle!==undefined && item.ptitle.toLowerCase().includes(filterValue.toLowerCase())) {

                                if (!isInObject(nfp, item,'ptitle')) {
                                    nfp.push(item)
                                }
                            }

                            if (item.name!==undefined && item.name.toLowerCase().includes(filterValue.toLowerCase())) {

                                if (!isInObject(nfp, item,'name')) {
                                    nfp.push(item)
                                }
                            }

                            if (item.identifier!==undefined && item.identifier.toLowerCase().includes(filterValue.toLowerCase())) {

                                if (!isInObject(nfp, item,'identifier')) {
                                    nfp.push(item)
                                }
                            }

                        })

                        filteredItems = nfp
                    }


                    break
                case 'pagination':

                    if (filterValue) {
                        let pagination = chunk(convertToArray(filteredItems), parseInt(filterValue))
                       
                        dispatch(actions.setPagination(pagination))
                        filteredItems = pagination[0]

                    } else {
                        dispatch(actions.setPagination(null))
                    }

                    break;

            }


        })


        dispatch(actions.setFilteredItems(filteredItems))


    }

    const convertToArray = (obj) => {
        if (Array.isArray(obj)) {
            return obj
        }

        let array = []

        Object.keys(obj).forEach(key => {
            array[key] = obj[key]
        })

        return array
    }

    const isInObject = (obj, item) => {

        let isInObject = false

        Object.keys(obj).forEach((key) => {
            let objectItem = obj[key]

            if (objectItem.id == item.id) {
                isInObject = true
            }
        })

        return isInObject
    }

    const chunk = (array, chunkSize) => {

        const chunks = [];
        for (let i = 0; i < array.length; i += chunkSize) {

            chunks.push(array.slice(i, i + chunkSize));
        }
        return chunks;
    }

    const resort = (obj, field, type = 'ASC') => {

        switch (type) {
            case 'ASC':

                return Object.values(obj).sort((a, b) => a[field] > b[field]?1:-1)

            case 'DESC':
                return Object.values(obj).sort((a, b) => b[field] < a[field]?-1:1)

        }
    }




    return {

        doFilter,
        resort,
        convertToArray
    }
}